import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
var GitHubIcon = function GitHubIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.552 5.083c.835-1.55-.119-3.578-.119-3.578-2.147 0-3.697 1.43-3.697 1.43-.835-.476-3.578-.476-3.578-.476s-2.743 0-3.578.477c0 0-1.55-1.431-3.698-1.431 0 0-.954 2.027-.119 3.578 0 0-1.908 1.789-1.192 5.605.672 3.586 3.816 4.532 5.844 4.532 0 0-.835.716-.716 1.908 0 0-1.193.716-2.385.24-1.193-.478-1.79-1.67-1.79-1.67s-1.192-1.551-2.385-.955c0 0-.357.358.954.954 0 0 .955 1.431 1.312 2.266.358.835 2.266 1.55 4.175 1.074v2.743s0 .238-.477.358c-.477.119-.477.357-.239.357h8.587c.239 0 .239-.238-.238-.357-.477-.12-.477-.358-.477-.358v-2.743s.01-1.43 0-1.909a2.781 2.781 0 0 0-.835-1.908c2.027 0 5.171-.946 5.844-4.532.715-3.816-1.193-5.605-1.193-5.605Z"
  }));
};
export default GitHubIcon;